@if (!isHidden() && !hideList()) {
  <div
    [class]="cx()"
    data-rr-shared="true"
  >
    <ul [class]="cx('list')">
      @for (item of state().items; track item.label + '_' + item.value + '_' + item.isRefined) {
        <li
          [class]="getItemClass(item)"
          (click)="clickRefinement($event, item)"
        >
          <label [class]="cx('label')">
            <input
              [class]="cx('checkbox')"
              type="checkbox"
              value="{{item.value}}"
              [checked]="item.isRefined"
            />
            <span [class]="cx('labelText')">
              @if (item.label.indexOf('icon-') !== -1) {
                <img [height]="20" [ngSrc]="getIcon(item.label)" [width]="20"
                     alt="icon">
              }
              {{ getLabel(item.highlighted) }}
            </span>
            <span [class]="cx('count')">{{ item.count }}</span>
          </label>
        </li>
      }
    </ul>
    @if (showMore()) {
      <button
        [class]="cx('showMore')"
        (click)="clickShowMore()"
        [disabled]="!state().canToggleShowMore"
      >
        {{ state().isShowingMore ? showLessLabel() : showMoreLabel() }}
      </button>
    }
  </div>
}
